import React from "react";
import { useDomainEngagementData } from "./useDomainEngagementData";

export const DomainEngagementTable = ({
  displayDateString,
  dataViewMode,
  focusDate,
  previousDate,
  optionsShort,
  pDistChange,
  eDistChange,
  aDistChange,
  rDistChange,
  lDistChange,
  iDistChange,
}) => {
  const { domains, totalPrev, totalCurr, totalDiff, totalColor } =
    useDomainEngagementData({
      pDistChange,
      eDistChange,
      aDistChange,
      rDistChange,
      lDistChange,
      iDistChange,
    });

  /** Safely calculate % change */
  const safePercent = (diff, base) =>
    base > 0 && !isNaN(diff) ? ((diff / base) * 100).toFixed(1) + "%" : "N/A";

  /** Safely calculate % of total */
  const percentOfTotal = (value, total) => {
    if (!value || isNaN(value) || total <= 0) return "0.0";
    return ((value / total) * 100).toFixed(1);
  };

  return (
    <div
      className="pearli-table-card"
      style={{ height: "440px", width: "650px" }}
    >
      <div className="admin-section-item-header">
        <div className="pearli-table-card-title">
          Domain Engagement Summary ({displayDateString})
        </div>
        <div className="pearli-table-card-subtitle">
          Showing monthly clicks per domain with month comparison % change
        </div>
      </div>

      <div className="pearli-table-scroll">
        <table className="pearli-table">
          <thead>
            <tr>
              <th className="pearli-th">Domain</th>
              {dataViewMode !== "current" && (
                <th className="pearli-th">
                  {previousDate
                    ? previousDate.toLocaleDateString("en-US", optionsShort)
                    : "Loading"}
                </th>
              )}
              <th className="pearli-th">
                {dataViewMode === "current"
                  ? displayDateString
                  : focusDate
                  ? focusDate.toLocaleDateString("en-US", optionsShort)
                  : "Loading"}
              </th>
              <th className="pearli-th">% of Total</th>
              {dataViewMode !== "current" && (
                <>
                  <th className="pearli-th">Change</th>
                  <th className="pearli-th">Change(%)</th>
                </>
              )}
            </tr>
          </thead>

          <tbody>
            {domains.map(([label, arr]) => {
              const color =
                arr[3] === "N/A"
                  ? "#EF4444"
                  : arr[3] > 0
                  ? "#19B880"
                  : arr[3] === 0
                  ? "#334155"
                  : "#EF4444";

              const domainPercent =
                totalCurr > 0 ? percentOfTotal(arr[1], totalCurr) : "0.0";

              return (
                <tr key={label}>
                  <td className="pearli-td">{label}</td>

                  {dataViewMode !== "current" && (
                    <td className="pearli-td">{arr[0]}</td>
                  )}

                  <td className="pearli-td">{arr[1]}</td>
                  <td className="pearli-td">{domainPercent}%</td>

                  {dataViewMode !== "current" && (
                    <>
                      <td className="pearli-td" style={{ color }}>
                        {arr[3] > 0 ? `+${arr[3]}` : arr[3]}
                      </td>
                      <td className="pearli-td" style={{ color }}>
                        {safePercent(arr[3], arr[0])}
                      </td>
                    </>
                  )}
                </tr>
              );
            })}

            {/* --- Total Row --- */}
            <tr>
              <td className="pearli-td" style={{ fontWeight: "700" }}>
                Total
              </td>

              {dataViewMode !== "current" && (
                <td className="pearli-td">{totalPrev}</td>
              )}

              <td className="pearli-td">{totalCurr}</td>
              <td className="pearli-td">{totalCurr > 0 ? "100%" : "0%"}</td>

              {dataViewMode !== "current" && (
                <>
                  <td className="pearli-td" style={{ color: totalColor }}>
                    {totalDiff > 0 ? `+${totalDiff}` : totalDiff}
                  </td>
                  <td className="pearli-td" style={{ color: totalColor }}>
                    {safePercent(totalDiff, totalPrev)}
                  </td>
                </>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
